import React from 'react';
import PropTypes from 'prop-types';

export const ModalCounterContext = React.createContext();

ModalCounterProvider.propTypes = {
    children: PropTypes.node.isRequired,
    onChange: PropTypes.func.isRequired,
};
export function ModalCounterProvider({children, onChange}) {
    let [count, setCount] = React.useState(0);

    React.useEffect(() => {
        onChange(count);
    }, [count, onChange]);

    return <ModalCounterContext.Provider value={setCount}>{children}</ModalCounterContext.Provider>;
}

export default function useModalCounter() {
    return React.useContext(ModalCounterContext);
}
